import moment from "moment";
import React, { Component } from "react";
import FlexView from "react-flexview";
import SimpleButton from "../../../../../../modules/commons/SimpleButton";
import SimpleDataTable from "../../../../../../modules/SimpleDataTable";
import SimpleDDL from "../../../../../../modules/SimpleDDL";
import { yearOptions } from "../../../config";
import { tableConfig, transformResponseLastThreeYearsToTable } from "./config";
import { fetchDataAsync } from "../../../../../../Services/Utils";
import Api from "../../../../../../Services/Api";
import { HttpStatus } from "../../../../../common/Constants";
import { transformChartL3Y } from "../service";
import CardBiaxialChart from "../../../../../../cards/BiaxialChart";
import { saveAs } from "file-saver";
import { buildExcelRequestBodyJualPartL3Y } from "../configExcel";

export default class LaporanPartL3Y extends Component {
  constructor(props) {
    super(props);
    this.state = {
      year: null,
      menuName: null,
      dataTable: [],
      chartData: [],
      chartKey: [],
      chartVisible: false,
    };
  }

  componentDidMount() {
    this.loadDDL();
  }

  loadDDL = () => {
    const currentYear = Number(moment().format("YYYY"));
    this.setState({
      year: yearOptions.find((item) => item.value === currentYear),
      menuName: "LAPORAN SERVICE 3 TAHUN TERAKHIR",
    });
  };

  handleChangeValue = (name, value) => {
    this.setState((prevValue) => ({ ...prevValue, [name]: value }));
  };

  handleSearch = () => {
    this.fetchData();
  };

  fetchData = async () => {
    console.log(this.props);

    try {
      this.props.triggerLoading();
      const res = await fetchDataAsync({
        asyncFn:
          Api.create("NAGAMAS_REPORT_DTO")
            .getLaporanJualan3TahunTerakhirByCabangH23,
        setError: this.props.setError,
        menuName:
          "Dashboard Level Kabeng Keatas - Laporan Jualan 3 Tahun Terakhir",
        args: {
          listKodeCabang: this.props.search,
          year: this.state.year.value,
        },
      });

      if (res.ok && res.data.status === HttpStatus.SUCCESS) {
        const rawData = res.data.data || [];

        const { data, dataKey } = transformChartL3Y(rawData);

        this.setState({
          dataTable: transformResponseLastThreeYearsToTable(rawData),
          chartData: data,
          chartKey: dataKey,
        });
      }

      this.props.triggerLoading();
    } catch (error) {
      this.props.triggerLoading();
      console.log("errors: ", error);
    }
  };

  handleChartVisibility = () => {
    this.setState((prevValue) => ({
      ...prevValue,
      chartVisible: !prevValue.chartVisible,
    }));
  };

  handlePrint = async () => {
    const { month, year, dataTable } = this.state;
    this.props.triggerLoading();

    try {
      const reqBody = buildExcelRequestBodyJualPartL3Y({
        year,
        dataTable
      });

      const res = await fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_REPORT").generateExcelFromPayload,
        menuName: "Dashboard Level Kabeng Keatas - Laporan Jual Part L3Y",
        setError: this.props.setError,
        args: reqBody,
      });

      if (res?.ok) {
        const blob = new Blob([res.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        saveAs(blob, `${reqBody.filename}.xlsx`);
      }
    } catch (error) {
      console.error("Error saat generate Excel:", error);
      this.props.setError("Gagal generate file Excel");
    } finally {
      this.props.triggerLoading();
    }
  };

  render() {
    const { year, menuName } = this.state;
    return (
      <React.Fragment>
        <FlexView className="margin-top-15px" style={{ gap: "20px" }}>
          <SimpleDDL
            id="select_options_tahun"
            box="search"
            name="year"
            containerclassname="width width-150px"
            placeholder="Tahun"
            options={yearOptions}
            value={year}
            onChange={(value, { name }) => this.handleChangeValue(name, value)}
          />
          <SimpleButton
            id="btn_search"
            text="Cari"
            className="margin margin-top-5px"
            onClick={this.handleSearch}
          />
        </FlexView>
        <p className="margin-bottom-20px txt-site txt-main txt-bold">
          {menuName}
        </p>
        {!this.state.chartVisible && (
          <SimpleDataTable
            data={this.state.dataTable}
            columns={tableConfig}
            options={{ pagination: false }}
          />
        )}
        {this.state.chartVisible && (
          <CardBiaxialChart
            data={this.state.chartData}
            dataKey={this.state.chartKey}
          />
        )}
        <FlexView style={{ justifyContent: "end", marginTop: "15px" }}>
          <SimpleButton
            id="btn_print"
            text="CETAK"
            style={{ marginRight: 5 }}
            onClick={() => this.handlePrint()}
          />
          <SimpleButton onClick={this.handleChartVisibility}>
            CHART
          </SimpleButton>
        </FlexView>
      </React.Fragment>
    );
  }
}
